// import persianDate from "persian-date";
import { useRef } from "react";
import { formatPrice } from "helpers/dataFormat";
import { useSelector } from "react-redux";
// @ts-ignore
import Num2persian from "num2persian";
//@ts-ignore
import persianDate from "persian-date";

export interface ICheque {
    id: string,
    dueDate: string
    amount: number
    nationalId: string
    inCash: string

}
const useChequePrint = (props?: { cheque: ICheque }) => {
    const cheque = props?.cheque
    const store = useSelector((state: any) => state);
    const chequeInfo: ICheque = cheque || store?.chequeReducer.cheque;
    const ref = useRef<any>(null);
    let content = <></>
    if (chequeInfo.id && chequeInfo.dueDate) {

        const shamsiDate = chequeInfo.dueDate//MiladiToJalali(Number(arrDate[0]), Number(arrDate[1]), Number(arrDate[2]))
        const splited = shamsiDate.split("/")
        const persianDueDateWord = new persianDate(shamsiDate).format("DD/MMMM/YYYY")
        const nesplited = persianDueDateWord.split('/')
        const okeydate = `${Num2persian(Number(splited[2]))} ${nesplited[1]} ${Num2persian(Number(splited[0]))}`
        const persianDueDate = new persianDate(shamsiDate).format("YYYY/MM/DD")
        content = (
            <div ref={ref} dir="rtl" className="w-[642px] h-[320px] bg-white flex flex-col text-black p-4 border">
                <span className="mr-[50px]   mt-2 font-bold">{persianDueDate}</span>
                <span className="mr-[50px] mt-2 font-bold">{okeydate}</span>
                <span className="mr-[55px]  mt-5 font-bold w-[450px] text-wrap">{Num2persian(chequeInfo.amount)} ریال تمام</span>
                <div className="flex justify-between ">
                    <span className="mr-[60] font-bold">{chequeInfo.inCash} </span>
                    <span className="ml-[200px] font-bold">{chequeInfo.nationalId} </span>
                </div>
                <div className="flex justify-end w-full">
                    <span className="mt-8 ml-[100px] text-xl font-bold">
                        {formatPrice(chequeInfo.amount)}
                    </span></div>

            </div>)
    }
    return { chequeContent: content, cheqRef: ref };
}

export default useChequePrint;